import {AssociationBattleProps} from './types'
import AssociationBattle from './AssociationBattle'
import * as React from 'react'
import { LoadScriptProps, useLoadScript } from '@react-google-maps/api'
import LoadingIndicator from '../Shared/Components/LoadingIndicator'
import { useTranslation } from 'react-i18next'
import { DEFAULT_LANGUAGE } from '../Shared/Constants/Language'
import ComponentError from '../Shared/Components/ComponentError'

const AssociationBattleLoader = (props: AssociationBattleProps) => {
    const { t, i18n } = useTranslation()
    const currentLang = i18n.language || DEFAULT_LANGUAGE
    const googleMapsLibraries: LoadScriptProps['libraries'] = ["places"];

    const { isLoaded, loadError } = useLoadScript({
        googleMapsApiKey: props.googleMapsApiKey? props.googleMapsApiKey : '' ,
        language: currentLang,
        libraries: googleMapsLibraries,
    })

    if (loadError) {
        return (
            <ComponentError
                errorMessages={[t('recyclingStations.mapLoadingError')]}
            />
        )
    }

    return isLoaded ? (
        <AssociationBattle {...props} />
    ) : (
        <LoadingIndicator customMargins="5rem 0" />
    )

}

export default AssociationBattleLoader
